/**
 * Internal dependencies
 */
import cecSdk from 'lib/customer-ec-sdk';
import * as actions from 'state/action-types';
import receiveLocations from './receive-locations';

export default () => (dispatch) => {
    dispatch({
        type: actions.LOCATIONS_REQUEST,
    });

    return cecSdk
        .location()
        .listAll()
        .then((locations) => {
            dispatch({
                type: actions.LOCATIONS_REQUEST_SUCCESS,
            });
            dispatch(receiveLocations(locations));
            return locations;
        })
        .catch((e) => {
            dispatch({ type: actions.LOCATIONS_REQUEST_FAILURE, error: e.message });
            throw e;
        });
};
